import { Component } from "@angular/core";
import { Subject, Observable } from "rxjs";

@Component({
  selector: 'lfwms-custom-value',
  templateUrl: './custom-value.component.html',
  styleUrls: ['./custom-value.component.css']
})
export class CustomValueComponent {
  customValue: string = '';
  private eventSubject: Subject<any> = new Subject<any>();

  initializeComponents(): void {
    // Initialize component logic
  }

  receiveEvent(): Observable<any> {
    return this.eventSubject.asObservable();
  }
  
  public notifyEvent(event : any) {
    this.eventSubject.next(event);
  }

  addCustomValue() {
    this.notifyEvent({ customValue: this.customValue });
  }

  closeCustomValueModal() {
    this.notifyEvent({ customValue: null });
  }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/dropdown/custom-value/custom-value.component.ts